import React from "react";
import { cloneDeep } from 'lodash';
import 'flag-icon-css/css/flag-icons.min.css';

import countriesJson from '../../../public/json/countries.json';
import CurrencyList from 'currency-list';

export const getCountryOptions = () => {
  const countries = cloneDeep(countriesJson);
  const options = countries.countries.map((item) => {
    item.id = item.code;
    item.value = item.code;
    item.label = (
      <div className="label">
        <span className={`flag-icon flag-icon-${item.code.toLowerCase()} flag-icon-squared`}></span>
        <span className="flag-text ml-5">
          {item.dial_code}
          {' '}
          {item.name_es}
        </span>
      </div>
    );
    return item;
  });

  return options;
}

export const getCurrencyOptions = () => {
  const currencies = cloneDeep(CurrencyList.getAll('es_ES'));
  if (!currencies) return [];

  const options = [];
  let name;

  Object.keys(currencies).forEach((key) => {
    name = currencies[key].name.charAt(0).toUpperCase() + currencies[key].name.slice(1);
    options.push({ value: currencies[key].code, label: `${name} - ${currencies[key].code}` });
  });

  return options;
}

export const filterOption = ({ value, data }, string) => {
  if (!string) return true;

  const searchString = string.toLowerCase();

  return data.name_es.toLowerCase().includes(searchString) ||
    data.name_en.toLowerCase().includes(searchString) ||
    data.dial_code.includes(searchString) ||
    value.toLowerCase().includes(searchString);
};

export const customCountryFormatOptionLabel = ({ value, dial_code, name_es }, { context }) => {
  return (
    <div className="label">
      <span className={`flag-icon flag-icon-${value.toLowerCase()} flag-icon-squared`}></span>
      <span className="flag-text ml-5">
        {context === "menu" ? (
          <>
            {dial_code}
            {' '}
          </>
        ) : null}
        {name_es}
      </span>
    </div>
  );
};

/**
 * Extracts country code from phone number and returns the flag icon
 * @param {string} phoneWithCountryCode - Phone number with country code (e.g., "+29743534534543")
 * @param {string} phoneWithoutCountryCode - Phone number without country code (e.g., "43534534543")
 * @returns {string|null} Country code (e.g., "AW") or null if not found
 */
export const getCountryCodeFromPhone = (phoneWithCountryCode, phoneWithoutCountryCode) => {
  if (!phoneWithCountryCode || !phoneWithoutCountryCode) return null;

  // Extract the dial code by removing the phone without country code from the full phone
  const dialCode = phoneWithCountryCode.replace(phoneWithoutCountryCode, '');

  // Find the country in the JSON that matches this dial code
  const countries = cloneDeep(countriesJson);
  const country = countries.countries.find((c) => c.dial_code === dialCode);

  return country ? country.code : null;
};

/**
 * Returns the flag icon element for a given country code
 * @param {string} countryCode - ISO country code (e.g., "AW")
 * @param {string} className - Optional classes to append
 * @returns {JSX.Element|null} Flag icon element or null
 */
export const getFlagIcon = (countryCode, className = '') => {
  if (typeof countryCode !== 'string') return null;
  const normalizedCode = countryCode.trim().toLowerCase();
  if (!/^[a-z]{2}$/.test(normalizedCode)) return null;

  const classes = [
    'flag-icon',
    `flag-icon-${normalizedCode}`,
    'flag-icon-squared',
    className
  ].filter(Boolean).join(' ');

  return (
    <span className={classes}></span>
  );
};
